/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import Card from "./card";
import { useNavigate } from "react-router-dom";
import bettingService from "../../../api/services/bettingService";
import { useTranslation } from "react-i18next";
import Modal from "../../common/components/modal/index";
import { useDispatch } from "react-redux";
import { playSong, setBodyEvents, setEvents, setMixEvents } from "../../common/actions/common.actions";
import { useSelector } from 'react-redux';
import { selectLoginData } from "../login/login.actions";
import { setConfirmData } from '../../common/actions/common.actions';
import { IoIosArrowBack } from "react-icons/io";
import { HiMiniSparkles } from "react-icons/hi2";
import { MdOutlineVerified } from "react-icons/md";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { TbTargetArrow } from "react-icons/tb";

const ConfirmBet = ({ onClose, showToastMessage, setIsLoading }) => {
    const { confirmData } = useSelector((state) => state.common);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [predictAmount, setPredictAmount] = useState(0);
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState('');
    const [oddList, setOddList] = useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    useEffect(() => {
        getData();
    }, []);

    const { userDetails } = useSelector(selectLoginData);

    const getData = () => {
        setUserData(userDetails);
    }

    useEffect(() => {
        if (userData && confirmData) {
            userBettingCheck();
            predictProfit();
        }
    }, [userData, confirmData]);

    const selectedMatches = confirmData?.selectedMatches || [];
    const selectedCount = selectedMatches.length;
    const isMixBet = confirmData?.isMix || selectedCount > 1;

    const userBettingCheck = async () => {
        try {
            const payload = {
                userId: userData.userId,
                Odd: confirmData?.selectedMatches?.reduce((a, c) => {
                    a.push({ eventId: c.eventId });
                    return a;
                }, []),
            };
            const res = await bettingService
                .userBettingCheck(payload)
                .then((response) => response.json());
            if (res && res.odd && res.odd.length > 0) {
                const changeEventList = res.odd.reduce((a, c) => {
                    a.push(c.eventId);
                    return a;
                }, []);
                setOddList(changeEventList);
            }
            return res;
        } catch (e) {
            console.log("Error :", e);
        }
    };

    const predictProfit = async () => {
        try {
            const payload = {
                gamblingAmount: Number.parseInt(confirmData.betAmount),
                teamCount: confirmData.selectedMatches.length,
                isFivePercent: confirmData.selectedMatches[0].isFivePercent,
            };
            const res = await bettingService
                .predictProfit(payload)
                .then((response) => response.json());
            if (res) {
                setPredictAmount(res.predictAmount);
            }
        } catch (e) {
            console.log("Error :", e);
        }
    };

    const handleSongClick = async () => {
        dispatch(playSong());
    };

    const handleConfirmData = async (data) => {
        dispatch(setConfirmData(data));
    };

    const goBack = () => {
        handleSongClick();
        navigate(-1);
    };

    const checkValidate = async () => {
        const checkData = await userBettingCheck();
        if (checkData?.islock) {
            localStorage.removeItem('token');
            localStorage.removeItem('userDetails');
            localStorage.removeItem('confirmData');
            navigate("/login");
            return
        }
        if (checkData) {
            const currentTime = new Date(checkData.serverTime?.currentTime);
            const userInfo = checkData.userInfo[0];
            if (confirmData && confirmData.selectedMatches && confirmData.selectedMatches.length > 0) {
                if (Number.parseInt(confirmData.betAmount) > userInfo.balance) {
                    return 'User balance is lower than bet amount!';
                }
                if (confirmData.isMix && confirmData.selectedMatches.length < 2) {
                    return 'Please select at least 2 match!';
                }
                const error = await confirmData.selectedMatches.reduce((a, c) => {
                    if (new Date(c.eventTime) <= currentTime) {
                        a = `${c.homeTeam} and ${c.awayTeam} match is over time!`;
                    }
                    return a;
                }, '');
                return error;
            } else {
                return 'Please select at least 1 match!';
            }
        } else {
            return '';
        }
    }

    const confirmBetting = async () => {
        if (isButtonDisabled) return;
        setIsLoading(true);
        if (!confirmData) {
            navigate(-1);
            return;
        };
        setIsButtonDisabled(true);
        const errorMsg = await checkValidate();
        if (errorMsg) {
            if (errorMsg.includes("match is over time!")) {
                handleConfirmData(null);
            }
            setIsLoading(false);
            openModal('EP SPORTS', errorMsg);
            return;
        }
        handleSongClick();
        try {
            const date = new Date();
            const yearLastTwoDigits = date.getFullYear() % 100;
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hour = String(date.getHours()).padStart(2, '0');
            const minute = String(date.getMinutes()).padStart(2, '0');
            const second = String(date.getSeconds()).padStart(2, '0');

            const postNo = 'GB' + userData.roleId.toString() + userData.userId.toString() + yearLastTwoDigits.toString() +
                month.toString() + day.toString() + hour.toString() + minute.toString() + second.toString();
            const payload = {
                postingNo: postNo,
                gamblingTypeId: confirmData.selectedMatches.length === 1 ? 1 : 2,
                teamCount: confirmData.selectedMatches.length,
                amount: Number.parseInt(confirmData.betAmount),
                active: true,
                selectedDate: confirmData.selectedMatches[0].selectedDate,
                userId: userData.userId,
                details: confirmData.selectedMatches.reduce((a, c) => {
                    const obj = {
                        eventId: c.eventId,
                        rapidEventId: c.rapidEventId,
                        leagueId: c.leagueId,
                        footballTeamId: c.choosen === 'home' ? c.homeId : c.choosen === 'away' ? c.awayId : 0,
                        unders: c.choosen === 'under',
                        overs: c.choosen === 'over',
                        bodyOdd: c.bodyHandicap,
                        goalOdd: c.goalHandicap,
                        home: c.choosen === 'home',
                        away: c.choosen === 'away',
                        isHome: c.choosen === 'away' ? false : true,
                        oppositeNameId: c.choosen === 'away' ? c.homeId : c.choosen === 'home' ? c.awayId : 0,
                        isHomeBodyOdd: c.overId === c.homeId ? true : false,
                        isFivePercentCom: confirmData.selectedMatches[0].isFivePercent,
                    };
                    a.push(obj);
                    return a;
                }, [])
            };
            await bettingService
                .confirmBetting(payload)
                .then((response) => response.json());
            handleConfirmData(null);
            dispatch(setMixEvents([]));
            dispatch(setBodyEvents([]));
            dispatch(setEvents([]));
            openModal('EP SPORTS', 'လောင်းခြင်းအောင်မြင်ပါသည် ✓✓✓✓');
            handleConfirmData(null);
        } catch (e) {
            openModal('EP SPORTS', 'လောင်းခြင်းမအောင်မြင်ပါ!');
            console.log("Error :", e);
        } finally {
            setIsLoading(false);
            setIsButtonDisabled(false);
        }
    }

    const handleRemoveCard = (rapidEventId) => {
        const newData = confirmData?.selectedMatches.filter(x => x.rapidEventId !== rapidEventId);
        handleConfirmData({ betAmount: confirmData.betAmount, selectedMatches: newData, isMix: confirmData.isMix || false });
        getData();
    }

    const openModal = (title, content) => {
        setModalTitle(title);
        setModalContent(content);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        navigate(-1);
    };

    return (
        <div className="relative flex h-[100dvh] w-full flex-col overflow-hidden bg-[radial-gradient(circle_at_top_left,_rgba(229,8,42,0.12),_transparent_34%),radial-gradient(circle_at_top_right,_rgba(30,90,142,0.14),_transparent_28%),linear-gradient(180deg,#f8fafc_0%,#eef2f7_100%)]" data-aos="fade-right">
            <div className="pointer-events-none absolute inset-x-0 top-0 h-56 bg-[linear-gradient(135deg,rgba(165,13,33,0.08),rgba(231,8,42,0.04),transparent)]" />

            <div className="relative z-10 border-b border-white/70 bg-white/78 shadow-[0_10px_40px_rgba(15,23,42,0.08)] backdrop-blur-xl">
                <div className="flex items-center justify-between px-5 py-3">
                    <button
                        onClick={goBack}
                        className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/80 bg-white/80 text-blue-primary transition-all duration-300 hover:border-crimson/25 hover:bg-crimson/5"
                    >
                        <IoIosArrowBack size={24} />
                    </button>
                    <div className="text-center">
                        <h3 className="text-lg font-bold text-blue-primary">{t('confirmBet')}</h3>
                    </div>
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-crimson via-red-primary to-crimson text-white shadow-lg">
                        <HiMiniSparkles size={18} />
                    </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-crimson via-golden to-crimson shadow-lg"></div>
            </div>

            <div className="relative z-10 flex-1 overflow-auto">
                <div className="mx-auto flex w-full max-w-3xl flex-col gap-2">

                    <div className="rounded-md border border-white/80 bg-white/76 p-1">
                        <div className="space-y-1">
                            {selectedMatches.map((data, ind) => {
                                return (
                                    <Card
                                        key={data.eventId || ind}
                                        number={ind + 1}
                                        team1={data.homeTeam}
                                        team2={data.awayTeam}
                                        normalColor={oddList && oddList.length > 0 ? !oddList.includes(data.eventId) : true}
                                        odd={
                                            data.choosen === 'over' || data.choosen === 'under'
                                                ? data.goalHandicap
                                                : data.bodyHandicap
                                        }
                                        choosen={data.choosen}
                                        match={data}
                                        handleRemoveCard={handleRemoveCard}
                                    />
                                );
                            })}
                        </div>

                        {selectedCount === 0 && (
                            <div className="rounded-md border border-dashed border-slate-300 bg-slate-50 px-4 py-10 text-center">
                                <p className="text-lg font-bold text-blue-primary">No matches selected</p>
                                <p className="mt-2 text-sm text-blue-primary/65">
                                    Go back and choose at least one match to continue.
                                </p>
                            </div>
                        )}
                    </div>



                    <div className="border border-amber-200 bg-amber-50/80 px-5 py-2 text-sm text-amber-800">
                        <div className="flex items-center gap-3">
                            <MdOutlineVerified size={22} className="mt-0.5 shrink-0 text-amber-700" />
                            <div>
                                <p className="font-bold uppercase tracking-[0.18em] text-amber-800/80">
                                    Final Check
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative z-10 mt-auto border-t border-white/70 bg-white/82 px-4 py-3 shadow-[0_-12px_35px_rgba(15,23,42,0.08)] backdrop-blur-xl sm:px-5">
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-crimson via-golden to-crimson shadow-lg"></div>
                <div className="mx-auto flex w-full max-w-3xl flex-col gap-1 md:flex-row md:items-center md:justify-between">
                    <div className="flex items-center justify-between rounded-3xl border border-slate-200 bg-slate-50 px-4 py-3 md:min-w-[320px]">
                        <div>
                            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-blue-primary/50">
                                Total Stake
                            </p>
                            <p className="text-xl font-bold text-blue-primary">
                                {Number(confirmData?.betAmount || 0).toLocaleString()}
                            </p>
                        </div>
                        <div className="h-8 w-px bg-slate-200" />
                        <div className="text-right">
                            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-emerald-700/55">
                                Est. Return
                            </p>
                            <p className="text-xl font-bold text-emerald-700">
                                {Number(predictAmount || 0).toLocaleString()}
                            </p>
                        </div>
                    </div>

                    <button
                        onClick={confirmBetting}
                        className="w-full rounded-3xl bg-gradient-to-r from-crimson via-red-primary to-crimson px-6 py-3 text-base font-bold tracking-[0.18em] text-white shadow-[0_18px_32px_rgba(229,8,42,0.28)] transition-all duration-300 hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-50 md:w-auto md:min-w-[260px]"
                        disabled={isButtonDisabled}
                    >
                        CONFIRM BET
                    </button>
                </div>
            </div>
            {isModalOpen && (
                <Modal title={modalTitle} content={modalContent} onClose={closeModal} />
            )}
        </div>
    );
};

export default ConfirmBet;
